import { render, staticRenderFns } from "./startDrawModal.vue?vue&type=template&id=23daaa39&scoped=true"
import script from "./startDrawModal.vue?vue&type=script&lang=js"
export * from "./startDrawModal.vue?vue&type=script&lang=js"
import style0 from "./startDrawModal.vue?vue&type=style&index=0&id=23daaa39&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23daaa39",
  null
  
)

export default component.exports